var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2145D7",
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.03 7.73 1.575 2.547c.91 1.286 3.033 1.239 3.93-.156 0 0 .878-1.13.08-2.579 0 0-2.538-5.44-4.535-6.721-.27-.174-4.51-3.343-8.452 4.066L.291 19.408c-.854 1.489.279 3.332 1.991 3.242h.011a2.17 2.17 0 0 0 1.748-1.052l8.276-13.853c.838-1.403 2.866-1.411 3.713-.015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.778 2.35h-.011a2.17 2.17 0 0 0-1.748 1.053l-8.276 13.853c-.838 1.402-2.864 1.409-3.712.014l-1.575-2.547c-.91-1.286-3.032-1.239-3.93.156 0 0-.878 1.13-.08 2.579 0 0 2.538 5.44 4.536 6.721.27.174 4.51 3.343 8.451-4.066L32.77 5.592c.853-1.486-.279-3.33-1.992-3.241M37.97 18.883l-2.53-4.056a2.56 2.56 0 0 0-3.515-.816 2.56 2.56 0 0 0-.816 3.516l2.53 4.056a2.56 2.56 0 0 0 3.516.815 2.56 2.56 0 0 0 .815-3.515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h39v25H0z"
  })))));
};
export default SvgLogo;